module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.e162fb60.svg";